<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="المقدمة">
<h1><span dir="rtl">المقدِّمة</span></h1>
<p><span dir="rtl">لا أظنُّ أنَّ هناك سبيلًا لتقديم قصة كتبتُها بنفسي ووجداني، وشارك قلبي كثيرًا في تهذيب سطورها، إلا إنَّني قد أهمس لك بمغزى الرواية رغبةً منِّي في مساعدتك على الغوص في أعماق سطورها عوضًا عن أن تطفو على ضفاف كلماتها فقط.</span></p>
<p><span dir="rtl">حسنًا.. كلُّ ما في الأمر أنَّني أريدك أن تسلِّط الضوء على بعض الأماكن المظلمة مِن حياتك، علَّك تجد فيها ما يجعلك تشعُّ وتزداد إشراقًا.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?4746acc0